import {
  N_ArtworkSpec,
  N_NamedAnnotated,
} from "@specsheet-common/shared-types";

export const hasCopyPlacement = (
  specifications: N_NamedAnnotated<N_ArtworkSpec>[]
): boolean => specifications.some((p) => p.value.kind === "copy");
